import React, { useState, useEffect } from "react";
import "./ProcessorQCTable.scss";
import { styled } from "@mui/material/styles";
import {
  Grid,
  Box,
  // SvgIcon,
  Tab,
  Tabs,
  Snackbar,
  Alert,
  AlertTitle,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import Label from "../../Label/Label";
import moment from "moment";
// import {
//   getProDataForReset,
//   isSignatureUploaded,
//   pageRedirection,
//   qcReInitiateProVlm,
//   rejectData,
// } from "../../../redux/processor/actions";
import Authentication from "../../../components/Modal/PopupModal/PopupModal";
import ModalSign from "../../../components/Modal/Signature/ModalSign";
import QCRowRejectAndReviewNew from "../TemplateDriven/QCRowRejectAndReviewNew";
import QCEditableCell from "./QCEditableCell";
import QCComment from "../TemplateDriven/QCComment";
import {
  isSignatureUploaded,
  qcDataEntry,
  rejectValidatorData,
  validateData,
  valiPageRedirection,
} from "../../../redux/validator/actions";
import Validation from "../TemplateDriven/Validation";
import ValidationButton from "../TemplateDriven/ValidationButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { logObject } from "../../../config/logs";
import DataTypeSelector from "../TemplateDriven/DataTypeSelector";
import RangeSelector from "../TemplateDriven/RangeSelector";
import CellMenu from "../TemplateDriven/CellMenu";
import ValidatorValueEditableCell from "./ValidatorValueEditableCell";

// Styled Paper component
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "#1A2027" : "var(--bg-white)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const ValidatorQCTable = React.forwardRef((props, ref) => {
  const {
    // qcTemplateData,
    role,
    showParameterTable,
    // assignToValidator,
    // selectedFile
  } = props;

  // console.log(selectedFile)

  // const roleMapping = {
  //   preProcessor: "prePro",
  //   processor: "pro",
  //   validator: "vali",
  // };

  // const useRejectionCounts = (role, rejectionType) => {
  //   const roleKey = roleMapping[role];

  //   return useSelector(
  //     (state) =>
  //       state?.[roleKey]?.coorData?.mapping_details?.[
  //         `${rejectionType}RejectionCounts`
  //       ] || 0
  //   );
  // };

  const dispatch = useDispatch();
  const qcTemplateData = useSelector(
    (state) => state?.vali?.coorData?.mapping_details?.parametersData || []
  );

  // const reProcessEntireBatch = useSelector(
  //   (state) => state.vali?.coorData?.mapping_details?.reProcessEntireBatch
  // );

  const reProcess = useSelector(
    (state) => state?.vali?.coorData?.mapping_details?.reProcess || false
  );

  // const selectedFilesDataForProUpdate = useSelector(
  //   (state) => state?.vali?.selectedFilesDataForProUpdate
  // );

  const coordinatesData = useSelector((state) => {
    return state?.vali?.coorData?.coordinatesDetails;
  });

  const [parametersData, setParametersData] = useState([...qcTemplateData]);
  // const [sortOrder, setSortOrder] = useState({
  //   column: null,
  //   direction: "asc",
  // }); // State to track sort order

  const anyOperationPerformedOnEntirePage = React.useRef(false);

  const [columnWidths, setColumnWidths] = useState({
    sr: 20,
    parameter: 300,
    input: 80,
    input2: 90,
    input3: 50,
    input4: 50,
    input5: 70,
    input6: 60,
    input7: 90,
    input8: 120,
    input9: 80,
    dataType: 100,
    range: 90,
  });
  const [openAuth, setOpenAuth] = useState(false);
  const signUploaded = useSelector((state) => state?.vali?.signUploaded);
  const reProcessVlmCountsFromAPi = useSelector(
    (state) => state?.vali?.coorData?.mapping_details?.reProcessVlmCounts || 0
  );
  const [openSignPad, setOpenSignPad] = useState(false);
  // const [actionAndAutoSave, setActionAndAutoSave] = useState({
  //   action: "",
  //   autoSave: "",
  // });

  // const [processorsRejectionCounts, setProcessorsRejectionCounts] = useState(
  //   useRejectionCounts(role, "processors")
  // );
  // const [validatorsRejectionCounts, setValidatorsRejectionCounts] = useState(
  //   useRejectionCounts(role, "validator")
  // );
  const [rejectedCount, setRejectedCount] = useState(0);

  // const [isUpdateParameters, setIsUpdateParameters] = useState(false);
  // Handling window unload

  const [
    reProcessVlmCounts,
    // , setReProcessVlmCounts
  ] = useState(reProcessVlmCountsFromAPi || 0);

  const [isAlert, setAlert] = useState({
    open: false,
    message: "",
    title: "",
  });
  const [validatedAndRejectedCounts, setValidatedAndRejectedCounts] = useState({
    validated: 0,
    rejected: 0,
  });

  const [logs, setLogs] = useState([]);

  // const [rowRejectionData, setRowRejectionData] = useState([]);

  useEffect(() => {
    dispatch(isSignatureUploaded());

    window.addEventListener("beforeunload", beforeunloadFunc);

    return () => {
      window.removeEventListener("beforeunload", beforeunloadFunc);
    };
  }, []);

  useEffect(() => {
    let validatedCount = 0;
    let rejectedCount = 0;

    if (Array.isArray(parametersData)) {
      parametersData.forEach((entry) => {
        if (entry?.rowValidation?.isValidated) {
          validatedCount++;
        } else if (entry?.validatorRowRejection?.isRejected) {
          rejectedCount++;
        }
      });
    }
    setValidatedAndRejectedCounts({
      ...validatedAndRejectedCounts,
      validated: validatedCount,
      rejected: rejectedCount,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //   callMapData2("save", true); // Pass autosave=true here
  //   }, 120000);

  //   // Cleanup function to clear the interval if the component unmounts or if the repetition is no longer needed
  //   return () => clearInterval(intervalId);
  // }, []); // Empty dependency array ensures the effect runs only once after the component mounts

  React.useImperativeHandle(ref, () => ({
    mapData2: (action, rejectionRemark, batchRejection, autoSave) => {
      // setActionAndAutoSave({
      //   action: action,
      //   autoSave: autoSave,
      // });

      // if (autoSave === false && action === "saveAndNext") {
      //   if (signUploaded?.isSignatureUploaded !== undefined) {
      //     if (signUploaded?.isSignatureUploaded === true) {
      //       // const isAssignForValidator = process.env.REACT_APP_VALIDATOR_FOR_QC;
      //       // if (isAssignForValidator === "true") {
      //       if (assignToValidator) {
      //         callMapData2({
      //           action,
      //           rejectionRemark,
      //           batchRejection,
      //           autoSave,
      //         });
      //       } else {
      //         setOpenAuth(true);
      //       }
      //     } else if (signUploaded?.isSignatureUploaded === false) {
      //       setOpenSignPad(true);
      //     }
      //   }
      // } else {
      callMapData2({ action, rejectionRemark, batchRejection, autoSave });
      // }
    },
  }));

  const callMapData2 = ({
    action,
    rejectionRemark,
    batchRejection,
    autoSave,
  }) => {
    if (action !== "save") {
      if (rejectedCount >= 1) {
        action = "reject";
      }
    }
    const next = action === "saveAndNext" ? true : false;

    if (role === "validator") {
      if (action === "reject") {
        dispatch(
          rejectValidatorData({
            parametersData: parametersData,
            batch_id: localStorage.batchId,
            next: next,
            extractionType: "free_form",
            // extractionType: extractionType,
            rejection_remark: rejectionRemark,
            isDataRejectedByValidator: true,
            projectId: localStorage.projectId,
            entireBatchRejectedByVali: batchRejection === true ? true : false,
            logs: logs,
            // logs: [],
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autoSave,
          })
        );
        // setLogs([]);
      } else if (action === "saveAndNext") {
        let allValidatedData;
        if (parametersData) {
          allValidatedData = parametersData.every(
            (item) => item?.rowValidation?.isValidated
          );
        } else {
          allValidatedData = false;
        }

        // To add is_out_of_range flag used Validation() function which is declared for range heighlight
        if (allValidatedData) {
          parametersData.forEach((parameter, parameterIndex) => {
            let isOutOfRange = false;

            parameter?.mappings?.map((mapping, mappingIndex) => {
              let outRange = false;

              outRange = Validation(
                parameter?.dataType,
                parameter?.range,
                mapping?.value
              )?.error
                ? true
                : false;

              if (outRange === true) {
                isOutOfRange = true;
              }
              parametersData[parameterIndex].mappings[mappingIndex][
                "out_of_range"
              ] = outRange;
            });

            parametersData[parameterIndex]["is_out_of_range"] = isOutOfRange;
          });
          if (signUploaded?.isSignatureUploaded === false) {
            setOpenSignPad(true);
          } else if (signUploaded?.isSignatureUploaded === true) {
            setOpenAuth(true);
          }
        } else {
          setAlert({
            ...isAlert,
            open: true,
            message:
              "Some fields are not validated. Please validate them before continuing.",
            title: "Validation Error",
          });
        }
      } else if (action === "save") {
        dispatch(
          validateData({
            parametersData: parametersData,
            batch_id: localStorage.batchId,
            projectId: localStorage.projectId,
            next: next,
            extractionType: "free_form",
            partially_validated: true,
            logs: logs,
            // logs: [],
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autoSave,
            onSaveSuccess: () => {
              setLogs([]); // Clear logs after debugging
            },
          })
        );
        // setLogs([]);
      }
    }
  };

  const beforeunloadFunc = (e) => {
    if (anyOperationPerformedOnEntirePage.current) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  // Sorting logic for true and false only
  // const handleSort = (column) => {
  //   let direction = "asc";
  //   if (sortOrder.column === column && sortOrder.direction === "asc") {
  //     direction = "desc";
  //   }

  //   const sortedData = [...parametersData].sort((a, b) => {
  //     const aValue =
  //       a.mappings[0].response === "Yes"
  //         ? 1
  //         : a.mappings[0].response === "No"
  //         ? 0
  //         : -1;

  //     const bValue =
  //       b.mappings[0].response === "Yes"
  //         ? 1
  //         : b.mappings[0].response === "No"
  //         ? 0
  //         : -1;

  //     if (column === "yes") {
  //       // Sorting for "Yes" column: true -> false
  //       if (direction === "asc") {
  //         return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  //       } else {
  //         return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
  //       }
  //     } else if (column === "no") {
  //       // Sorting for "No" column: false -> true
  //       if (direction === "asc") {
  //         return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
  //       } else {
  //         return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  //       }
  //     }

  //     return 0; // Default return if no sorting
  //   });

  //   setParametersData(sortedData);
  //   setSortOrder({ column, direction });
  // };

  // const handleTrueCheckboxChange = (parameterIndex) => {
  //   const updatedParametersData = [...parametersData];
  //   updatedParametersData[parameterIndex] = {
  //     ...updatedParametersData[parameterIndex],
  //     mappings: [
  //       {
  //         ...updatedParametersData[parameterIndex].mappings[0],
  //         response: "Yes",
  //         processor: localStorage?.userName,
  //         processedDate: moment().format("DD-MMM-YYYY"),

  //         // updating/setting mapping for unmapped question, this logic is different as have in 1.3 or in parameter exraction
  //         fileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         pageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         tagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPreTagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPrePageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         lockedPreFileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         forNoPreProMappingDataEntryByPro: true,
  //       },
  //     ],
  //   };
  //   setParametersData(updatedParametersData);
  //   if (!anyOperationPerformedOnEntirePage.current) {
  //     anyOperationPerformedOnEntirePage.current = true;
  //   }
  // };

  // const handleFalseCheckboxChange = (parameterIndex) => {
  //   const updatedParametersData = [...parametersData];
  //   updatedParametersData[parameterIndex] = {
  //     ...updatedParametersData[parameterIndex],
  //     mappings: [
  //       {
  //         ...updatedParametersData[parameterIndex].mappings[0],
  //         response: "No",
  //         processor: localStorage?.userName,
  //         processedDate: moment().format("DD-MMM-YYYY"),

  //         // updating/setting mapping for unmapped question, this logic is different as have in 1.3 or in parameter exraction
  //         fileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         pageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         tagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPreTagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPrePageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         lockedPreFileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         forNoPreProMappingDataEntryByPro: true,
  //       },
  //     ],
  //     // response: false,
  //   };
  //   setParametersData(updatedParametersData);
  //   if (!anyOperationPerformedOnEntirePage.current) {
  //     anyOperationPerformedOnEntirePage.current = true;
  //   }
  // };

  // const handleNotSureCheckboxChange = (parameterIndex) => {
  //   const updatedParametersData = [...parametersData];
  //   updatedParametersData[parameterIndex] = {
  //     ...updatedParametersData[parameterIndex],
  //     mappings: [
  //       {
  //         ...updatedParametersData[parameterIndex].mappings[0],
  //         response: "Not Sure",
  //         processor: localStorage?.userName,
  //         processedDate: moment().format("DD-MMM-YYYY"),

  //         // updating/setting mapping for unmapped question, this logic is different as have in 1.3 or in parameter exraction
  //         fileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         pageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         tagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPreTagName:
  //           updatedParametersData[parameterIndex].mappings[0].tagName ||
  //           selectedFilesDataForProUpdate?.tagName,
  //         lockedPrePageNo:
  //           updatedParametersData[parameterIndex].mappings[0].pageNo ||
  //           selectedFilesDataForProUpdate?.pageNo,
  //         lockedPreFileNo:
  //           updatedParametersData[parameterIndex].mappings[0].fileNo ||
  //           selectedFilesDataForProUpdate?.fileNo,
  //         forNoPreProMappingDataEntryByPro: true,
  //       },
  //     ],
  //     // response: false,
  //   };
  //   setParametersData(updatedParametersData);
  //   if (!anyOperationPerformedOnEntirePage.current) {
  //     anyOperationPerformedOnEntirePage.current = true;
  //   }
  // };

  // Function to handle column resizing
  const handleResize = (column, newWidth) => {
    setColumnWidths((prevWidths) => ({ ...prevWidths, [column]: newWidth }));
  };

  const handleMouseDown = (column) => (event) => {
    event.preventDefault();
    const initialX = event.clientX;
    const initialWidth = columnWidths[column];
    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - initialX;
      const newWidth = Math.max(25, initialWidth + deltaX);
      handleResize(column, newWidth);
    };
    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.classList.remove("resizing");
    };
    document.body.classList.add("resizing");
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  // const CrossIcon = (props) => (
  //   <SvgIcon {...props}>
  //     <path d="M18 6L6 18M6 6l12 12" stroke="red" strokeWidth="2" />
  //   </SvgIcon>
  // );

  const onClickCellToRedirect = ({
    tagName,
    pageNo,
    fileNo,
    actual_page_number,
  }) => {
    if (actual_page_number !== "" && actual_page_number >= 0) {
      // if (pageNo !== "" && pageNo >= 0) {
      dispatch(
        valiPageRedirection({ fileNo, tagName, pageNo: actual_page_number })
      );
      // in processor the page may shift so passing actual_page_number as pageNo because pageNo is used in other code generated by backend
    }
  };

  const handleUserPermission = () => {
    dispatch(
      qcDataEntry({
        parametersData: parametersData,
        batch_id: localStorage.batchId,
        projectId: localStorage.projectId,
        next: true,
        extractionType: "free_form",
        // partially_validated: false,
        partial_data_entry: false,
        logs: logs,
        // logs: [],
        // autosave
        drug_type: localStorage.getItem("drugType"),
        project_name: localStorage.getItem("projectName"),
        // onSaveSuccess: () => {
        //   setLogs([]); // Clear logs after debugging
        // },
      })
    );
    // setLogs([]);
  };

  const handleEsignDialogBoxClose = () => {
    setOpenSignPad(false);

    setTimeout(() => {
      dispatch(isSignatureUploaded());
    }, 1500);
  };
  // new done
  const handleRowRejection = (parameterIndex, remark) => {
    // if (role === "processor") {
    //   parametersData[parameterIndex].mappings[0] = {
    //     ...parametersData[parameterIndex].mappings[0],
    //     processorCellRejection: {
    //       isRejected: true,
    //       remark: remark,
    //       date: moment(new Date()).format("DD-MMM-YYYY"),
    //       rejectedBy: localStorage?.userName,
    //     },
    //   };
    //   // setProcessorsRejectionCounts((prev) => prev + 1);
    // }
    if (role === "validator") {
      parametersData[parameterIndex].mappings[0] = {
        ...parametersData[parameterIndex].mappings[0],
        validatorCellRejection: {
          isRejected: true,
          remark: remark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      // setValidatorsRejectionCounts((prev) => prev + 1);
    }

    setRejectedCount((prevState) => (prevState >= 0 ? prevState + 1 : 0)); // increament counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);
    setValidatedAndRejectedCounts({
      ...validatedAndRejectedCounts,
      rejected:
        validatedAndRejectedCounts?.rejected >= 0
          ? validatedAndRejectedCounts?.rejected + 1
          : 0,
    });
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "validation",
        action: "Reject",
        parameter: parametersData[parameterIndex]?.query,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[0]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        value: parametersData[parameterIndex].mappings[0]?.response,
        rowColIndex: [
          parseInt(parameterIndex) + 1,
          // , parseInt(mappingIndex) + 1
        ],
        remark: remark,
        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
          ]?.pages[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
          ]?.imageUrl,
        ...(role === "processor"
          ? { processorRejected: true }
          : { validatorRejected: true }),
      }),
    ]);

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  // new done
  const deleteRowRejection = (parameterIndex) => {
    // if (role === "processor") {
    //   parametersData[parameterIndex].mappings[0] = {
    //     ...parametersData[parameterIndex].mappings[0],
    //     processorCellRejection: {},
    //   };

    //   // setProcessorsRejectionCounts((prev) => prev - 1);
    // }
    if (role === "validator") {
      parametersData[parameterIndex].mappings[0] = {
        ...parametersData[parameterIndex].mappings[0],
        validatorCellRejection: {},
      };

      // setValidatorsRejectionCounts((prev) => prev - 1);
    }
    setRejectedCount((prevState) => (prevState > 0 ? prevState - 1 : 0)); // decrement counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);
    setValidatedAndRejectedCounts({
      ...validatedAndRejectedCounts,
      rejected:
        validatedAndRejectedCounts?.rejected > 0
          ? validatedAndRejectedCounts?.rejected - 1
          : 0,
    });
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "validation",
        action: "Undo Rejection",
        parameter: parametersData[parameterIndex]?.query,
        rowColIndex: [parseInt(parameterIndex) + 1],
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[0]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        value: parametersData[parameterIndex].mappings[0]?.response,
        // remark: remark,
        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
          ]?.pages[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
          ]?.imageUrl,
      }),
    ]);
  };

  // not done yet
  const markAsResolveRejection = (parameterIndex, index) => {
    // In Pro ROle - mark rejection did by validator
    // if (role === "processor") {
    //   parametersData[parameterIndex].validatorRowRejection = {
    //     isResolved: true,
    //     date: moment(new Date()).format("DD-MMM-YYYY"),
    //     resolvedBy: localStorage?.userName,
    //     remark: parametersData[parameterIndex].validatorRowRejection?.remark,
    //   };
    //   setParametersData([...parametersData]);
    //   // setValidatorsRejectionCounts((prev) => prev - 1);
    // }
    // if (role === "preProcessor") {
    //   parametersData[parameterIndex].processorRowRejection = {
    //     isResolved: true,
    //     resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //     resolvedBy: localStorage?.userName,
    //     remark: parametersData[parameterIndex].processorRowRejection?.remark,
    //   };
    //   parametersData[parameterIndex]?.mappings?.forEach((mapping) => {
    //     mapping.reInitiateOcr = true;
    //   });
    //   setParametersData([...parametersData]);
    //   // setProcessorsRejectionCounts((prev) => prev - 1);
    // }
    // if (!anyOperationPerformedOnEntirePage.current) {
    //   anyOperationPerformedOnEntirePage.current = true;
    // }
    // setLogs((prevLogs) => [
    //   ...prevLogs,
    //   logObject({
    //     extractionType: "template",
    //     category: role === "preProcessor" ? "mapping" : "dataEntry",
    //     action: "Resolved Row Rejection",
    //     parameter: parametersData[parameterIndex]?.parameter,
    //     rowColIndex: [parseInt(parameterIndex) + 1],
    //   }),
    // ]);
  };

  // const handleAddQuestion = (newQuestions) => {
  //   setIsUpdateParameters(true);
  //   // add new parameter in to old existed parametersData retrived from template
  //   for (let i = 0; i < newQuestions.length; i++) {
  //     parametersData.push({
  //       query: newQuestions[i]?.question,

  //       mappings: [
  //         {
  //           tagName: "",
  //           pageNo: "",
  //           fileNo: "",
  //           value: "",
  //           response: "",
  //         },
  //       ],
  //     });
  //   }

  //   setParametersData([...parametersData]);

  //   // delete new parameter after added in to table
  //   if (!anyOperationPerformedOnEntirePage.current) {
  //     anyOperationPerformedOnEntirePage.current = true;
  //   }

  //   // let newParamDataInStringFormat = ``;
  //   // newQuestions.forEach((item, index) => {
  //   //   newParamDataInStringFormat = `${newParamDataInStringFormat}${
  //   //     index + 1
  //   //   }. Parameter: ${item?.parameter}, Sheet Name: ${item?.sheetName}  `;
  //   // });

  //   // setLogs((prevLogs) => [
  //   //   ...prevLogs,
  //   //   logObject({
  //   //     isActivity: true,
  //   //     extractionType: "template",
  //   //     category: "inputs",
  //   //     action: "Add New Parameters",
  //   //     data: newParamDataInStringFormat,
  //   //   }),
  //   // ]);
  // };

  const handleBlur = (text, parameterIndex) => {
    const updatedParametersData = [...parametersData];

    updatedParametersData[parameterIndex].query = text;

    setParametersData([...updatedParametersData]);

    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  const addComment = (parameterIndex, commment) => {
    parametersData[parameterIndex].validatorComment = commment;
    setParametersData([...parametersData]);
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "validation",
        action: "Add Comment",
        parameter: parametersData[parameterIndex]?.query,
        value: commment,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[0]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[0]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[0]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        rowColIndex: [parseInt(parameterIndex) + 1],

        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
          ]?.pages[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
          ]?.imageUrl,
      }),
    ]);
  };

  const deleteComment = (parameterIndex) => {
    parametersData[parameterIndex].validatorComment = "";
    setParametersData([...parametersData]);
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "free_form",
        category: "validation",
        action: "Delete Comment",
        parameter: parametersData[parameterIndex]?.query,
        value: parametersData[parameterIndex]?.processorComment,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[0]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[0]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[0]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        rowColIndex: [parseInt(parameterIndex) + 1],

        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
          ]?.pages[
            parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
          ]?.imageUrl,
      }),
    ]);
  };
  // const handleChangeReProcess = ({
  //   checked,
  //   parameterData,
  //   parameterIndex,
  // }) => {
  //   const mapping = parametersData[parameterIndex]?.mappings?.[0];

  //   if (checked) {
  //     mapping.reInitiateProVlm = true;
  //     mapping.proVlmPageNo = selectedFilesDataForProUpdate?.pageNo;
  //     mapping.proVlmTagName = selectedFilesDataForProUpdate?.tagName;
  //     mapping.proVlmFileNo = selectedFilesDataForProUpdate?.fileNo;
  //     setParametersData([...parametersData]);
  //     setReProcessVlmCounts((prevCnt) => prevCnt + 1);
  //   } else {
  //     delete mapping.reInitiateProVlm;
  //     delete mapping.proVlmPageNo;
  //     delete mapping.proVlmTagName;
  //     delete mapping.proVlmFileNo;
  //     setParametersData([...parametersData]);
  //     setReProcessVlmCounts((prevCnt) => prevCnt - 1);
  //   }
  // };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setAlert({ ...isAlert, open: false, message: "", title: "" });
    }

    setAlert({ ...isAlert, open: false, message: "", title: "" });
  };

  const onClickValidate = (action, parameterIndex) => {
    if (action === "validate") {
      parametersData[parameterIndex]["rowValidation"] = {
        ...parametersData[parameterIndex]["rowValidation"],
        isValidated: true,
        validator: localStorage?.userName,
        date: moment(new Date()).format("DD-MMM-YYYY HH:mm:ss"),
      };
      setValidatedAndRejectedCounts({
        ...validatedAndRejectedCounts,
        validated:
          validatedAndRejectedCounts?.validated >= 0
            ? validatedAndRejectedCounts?.validated + 1
            : 0,
      });
      // const logs = [];

      // parametersData[parameterIndex]?.mappings?.map((item, index) => {
      // logs.push(
      //   logObject({
      //     extractionType: "template",
      //     category: "validation",
      //     action: `Validate Cell`,
      //     parameter: parametersData[parameterIndex]?.parameter,
      //     dataType: parametersData[parameterIndex]?.dataType,
      //     rangeMin: parametersData[parameterIndex]?.range?.["min"],
      //     rangeMax: parametersData[parameterIndex]?.range?.["max"],
      //     coordinates: item?.coordinates,
      //     coordinatesValues: item?.coordinatesValues,
      //     tagName: item?.tagName,
      //     pageNo: item?.pageNo,
      //     fileNo: item?.fileNo,
      //     rowColIndex: [parseInt(parameterIndex) + 1, index + 1],
      //     value: item?.value,
      //     mbrName: selectedFile?.originalFileName,
      //     document:
      //       coordinatesData[
      //         parseInt(
      //           parametersData[parameterIndex]?.mappings[index]?.fileNo
      //         )
      //       ]?.pages[
      //         parseInt(
      //           parametersData[parameterIndex]?.mappings[index]?.pageNo
      //         )
      //       ]?.imageUrl,
      //   })
      // );
      // });
      // setLogs((prevLogs) => [...prevLogs, ...logs]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "free_form",
          category: "validation",
          action: `Validate`,
          parameter: parametersData[parameterIndex]?.query,
          dataType: parametersData[parameterIndex]?.dataType,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          // coordinates: item?.coordinates,
          // coordinatesValues: item?.coordinatesValues,
          pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
          tagName: parametersData[parameterIndex].mappings[0]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            // , index + 1
          ],
          value: parametersData[parameterIndex].mappings[0]?.response,
          // mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
            ]?.pages[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
            ]?.imageUrl,
        }),
      ]);
    } else {
      parametersData[parameterIndex]["rowValidation"] = {};
      setValidatedAndRejectedCounts({
        ...validatedAndRejectedCounts,
        validated:
          validatedAndRejectedCounts?.validated > 0
            ? validatedAndRejectedCounts?.validated - 1
            : 0,
      });
      // const logs = [];

      // parametersData[parameterIndex]?.mappings?.map((item, index) => {
      // logs.push(
      //   logObject({
      //     extractionType: "template",
      //     category: "validation",
      //     action: `Undo Cell Validation`,
      //     parameter: parametersData[parameterIndex]?.parameter,
      //     dataType: parametersData[parameterIndex]?.dataType,
      //     rangeMin: parametersData[parameterIndex]?.range?.["min"],
      //     rangeMax: parametersData[parameterIndex]?.range?.["max"],
      //     coordinates: item?.coordinates,
      //     coordinatesValues: item?.coordinatesValues,
      //     tagName: item?.tagName,
      //     pageNo: item?.pageNo,
      //     fileNo: item?.fileNo,
      //     rowColIndex: [parseInt(parameterIndex) + 1, index + 1],
      //     value: item?.value,
      //     mbrName: selectedFile?.originalFileName,
      //     document:
      //       coordinatesData[
      //         parseInt(
      //           parametersData[parameterIndex]?.mappings[index]?.fileNo
      //         )
      //       ]?.pages[
      //         parseInt(
      //           parametersData[parameterIndex]?.mappings[index]?.pageNo
      //         )
      //       ]?.imageUrl,
      //   })
      // );
      // });

      // setLogs((prevLogs) => [...prevLogs, ...logs]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "free_form",
          category: "validation",
          action: `Undo Validatio`,
          parameter: parametersData[parameterIndex]?.query,
          dataType: parametersData[parameterIndex]?.dataType,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          // coordinates: item?.coordinates,
          // coordinatesValues: item?.coordinatesValues,
          pageNo: parametersData[parameterIndex].mappings[0]?.pageNo,
          tagName: parametersData[parameterIndex].mappings[0]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[0]?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            // , index + 1
          ],
          value: parametersData[parameterIndex].mappings[0]?.response,
          // mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.fileNo)
            ]?.pages[
              parseInt(parametersData[parameterIndex]?.mappings[0]?.pageNo)
            ]?.imageUrl,
        }),
      ]);
    }
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  return (
    <Box>
      {showParameterTable === false && (
        <Box>
          {/* <Grid container>
            <Grid
              Item
              md={12}
              // className="addRow-dataMap"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Tabs
                // className="left-aligned-tabs"
                size="small"
                value={0}
                TabIndicatorProps={{
                  style: {
                    marginBottom: "2px", // Adds some space between the indicator and the tab text
                  },
                }}
                sx={{
                  minHeight: "35px", // Set minimum height for the Tabs component
                  height: "38px", // Set fixed height for the Tabs component
                  paddingTop: "5px",
                  paddingLeft: "20px",
                }}
              >
                // Parameter Table Tab //
                <Tab
                  label="QC Table"
                  // className="mapping_toggle_tab"
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#ffff !important",
                    transition: "background-color 0.3s",
                    minHeight: "20px", // Decrease the height of the tab
                    padding: "5px 10px", // Padding to make it look smaller
                    fontSize: "0.875rem", // Smaller font size
                    borderRadius: "6px",
                  }}
                />
              </Tabs>
            </Grid>
          </Grid> */}

          {/* <div style={{ overflow: "scroll" }}> */}
          <Grid
            container
            className={"qc-DataMapTable-wrap validationValidator"}
            style={{ width: "100%" }}
          >
            <Grid Item className="qc-table-row">
              <Item
                className="qc-DataMap-header qc-table-cell qc-resizable"
                style={{
                  width: columnWidths.sr,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
                onMouseDown={handleMouseDown("sr")}
              >
                <Label text="Sr." />
              </Item>

              <Item
                className="qc-DataMap-header qc-table-cell qc-resizable"
                style={{
                  width: columnWidths.parameter,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
                onMouseDown={handleMouseDown("parameter")}
              >
                <Label text="Parameters" />
              </Item>

              <Item
                className="datatype-wrap table-cell resizable"
                style={{
                  width: columnWidths.dataType,
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onMouseDown={handleMouseDown("dataType")}
              >
                <Label text="Data Type">Data Type</Label>
              </Item>

              <Item
                className="rangeSelect-wrap table-cell resizable"
                style={{
                  width: columnWidths.range,
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onMouseDown={handleMouseDown("range")}
              >
                <Label text="Range" />
              </Item>

              <Item
                className={`qc-DataMap-header qc-table-cell qc-resizable`}
                style={{
                  width: columnWidths.input,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                }}
                onMouseDown={handleMouseDown("input")}
                // onClick={() => handleSort("yes")}
              >
                <Label text="Response" />
                {/* {sortOrder.column === "yes" &&
                    (sortOrder.direction === "asc" ? (
                      <ArrowUpwardIcon size="small" fontSize="small" />
                    ) : (
                      <ArrowDownwardIcon size="small" fontSize="small" />
                    ))} */}
              </Item>

              {/* <Item
                  className={`qc-DataMap-header qc-table-cell qc-resizable`}
                  style={{
                    width: columnWidths.input2,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("no")}
                  onMouseDown={handleMouseDown("input2")}
                >
                  <Label text="No" />
                  {sortOrder.column === "no" &&
                    (sortOrder.direction === "asc" ? (
                      <ArrowUpwardIcon size="small" fontSize="small" />
                    ) : (
                      <ArrowDownwardIcon size="small" fontSize="small" />
                    ))}
                </Item> */}

              <Item
                className={`qc-DataMap-header qc-table-cell qc-resizable`}
                style={{
                  width: columnWidths.input7,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                }}
                // onClick={() => handleSort("not_sure")}
                onMouseDown={handleMouseDown("input7")}
              >
                <Label text="Old Value" />
              </Item>

              <Item
                className={`qc-DataMap-header qc-table-cell qc-resizable`}
                style={{
                  width: columnWidths.input8,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                }}
                onMouseDown={handleMouseDown("input8")}
              >
                <Label text="Value" />
              </Item>

              <Item
                className={`qc-DataMap-header qc-table-cell qc-resizable`}
                style={{
                  width: columnWidths.input5,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                }}
                // onClick={() => handleSort("no")}
                onMouseDown={handleMouseDown("input5")}
              >
                <Label text="Comment" />
              </Item>

              <Item
                className={`qc-DataMap-header qc-table-cell qc-resizable`}
                style={{
                  width: columnWidths.input9,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  display: "flex",
                }}
                // onClick={() => handleSort("no")}
                onMouseDown={handleMouseDown("input9")}
              >
                <Label text="Processor Comment" />
              </Item>

              <Item
                // className={`qc-DataMap-header qc-table-cell qc-resizable`}
                className={`last-labels `}
                style={{
                  width: columnWidths.input6,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "2px",
                  padding: "4px",
                }}
                // onClick={() => handleSort("no")}
                onMouseDown={handleMouseDown("input6")}
              >
                <Label text="Accept" padding="0px 0px" />
                <Label
                  text={validatedAndRejectedCounts?.validated}
                  padding="0px 0px"
                ></Label>
              </Item>

              {/* Rejection */}
              <Item
                // className={`qc-DataMap-header qc-table-cell qc-resizable reject-coloumn`}
                className={`last-labels `}
                style={{
                  width: columnWidths.input3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "2px",
                  padding: "4px",
                }}
                // onClick={() => handleSort("no")}
                onMouseDown={handleMouseDown("input3")}
              >
                <Label text="Reject" />
                <Label
                  text={validatedAndRejectedCounts?.rejected}
                  padding="0px 0px"
                ></Label>
              </Item>

              {reProcess && (
                <Item
                  // className={`qc-DataMap-header qc-table-cell qc-resizable`}
                  className={`last-labels `}
                  style={{
                    width: columnWidths.input4,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  // onClick={() => handleSort("no")}
                  onMouseDown={handleMouseDown("input4")}
                >
                  <Label text="Rejection Note" />
                </Item>
              )}
            </Grid>

            {parametersData?.map((parameterData, parameterIndex) => (
              <Grid Item className="qc-DataMapTable" key={parameterIndex}>
                <Item style={{ width: columnWidths.sr }}>
                  {parameterIndex + 1}
                </Item>

                <Item style={{ width: columnWidths?.parameter }}>
                  <QCEditableCell
                    query={parameterData?.query}
                    parameterIndex={parameterIndex}
                    handleBlur={handleBlur}
                    isDisabled={true}
                    onClickCellToRedirect={() =>
                      onClickCellToRedirect(parameterData?.mappings[0])
                    }
                  />
                  {/* <TextField
                      inputProps={{ readOnly: true }}
                      className="parameters-name"
                      multiline
                      id="standard-basic"
                      variant="standard"
                      value={parameterData?.query}
                      onClick={() =>
                        onClickCellToRedirect(parameterData?.mappings[0])
                      }
                    /> */}
                </Item>

                <Item
                  className="datatype-wrap-selector "
                  style={{ width: columnWidths.dataType }}
                >
                  <DataTypeSelector
                    parameterData={parameterData}
                    // onHandleChangeDatatype={onHandleChangeDatatype}
                    parameterIndex={parameterIndex}
                    // isDataRejectedByProcessor={
                    //   isDataRejectedByProcessor
                    // }
                    role={role}
                    // entireBatchRejectedByPro={
                    //   entireBatchRejectedByPro
                    // }
                  />
                </Item>

                <Item
                  className="range-selector "
                  style={{ width: columnWidths.range }}
                >
                  <RangeSelector
                    // handleRange={handleRange}
                    parameterIndex={parameterIndex}
                    dataType={parameterData?.dataType}
                    selectedRange={parameterData?.range}
                    role={role}
                    // entireBatchRejectedByPro={
                    //   entireBatchRejectedByPro
                    // }
                  />
                </Item>

                {/* <Item
                    // className="datatype-wrap"
                    style={{
                      width: columnWidths?.input,
                      justifyContent: "center",
                    }}
                  >
                    <Checkbox
                      checked={parameterData?.mappings[0]?.response === "Yes"}
                      disabled={true}
                    />
                  </Item>

                  <Item
                    // className="datatype-wrap"
                    style={{
                      width: columnWidths?.input2,
                      justifyContent: "center",
                    }}
                  >
                    <Checkbox
                      checked={parameterData?.mappings[0]?.response === "No"}
                      checkedIcon={<CrossIcon style={{ color: "red" }} />}
                      disabled={true}
                    />
                  </Item> */}

                <Item
                  // className="datatype-wrap"
                  style={{
                    width: columnWidths?.input,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  {parameterData?.mappings[0]?.response === "Yes" ? (
                    <>
                      <CheckCircleOutlineIcon
                        style={{
                          color:
                            parameterData?.mappings[0]?.response === "Yes"
                              ? "#4caf50"
                              : "#aaa",
                          marginRight: "5px",
                          verticalAlign: "middle",
                        }}
                      />
                      Yes
                    </>
                  ) : parameterData?.mappings[0]?.response === "No" ? (
                    <>
                      <CancelOutlinedIcon
                        style={{
                          color:
                            parameterData?.mappings[0]?.response === "No"
                              ? "#f44336"
                              : "#aaa",
                          marginRight: "5px",
                          verticalAlign: "middle",
                        }}
                      />
                      No
                    </>
                  ) : (
                    <></>
                  )}
                </Item>

                <Item
                  // className="datatype-wrap"
                  style={{
                    width: columnWidths?.input7,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  {parameterData?.mappings[0]?.actual_response === "Yes" ? (
                    <>
                      <CheckCircleOutlineIcon
                        style={{
                          color:
                            parameterData?.mappings[0]?.actual_response ===
                            "Yes"
                              ? "#4caf50"
                              : "#aaa",
                          marginRight: "5px",
                          verticalAlign: "middle",
                        }}
                      />
                      Yes
                    </>
                  ) : parameterData?.mappings[0]?.actual_response === "No" ? (
                    <>
                      <CancelOutlinedIcon
                        style={{
                          color:
                            parameterData?.mappings[0]?.actual_response === "No"
                              ? "#f44336"
                              : "#aaa",
                          marginRight: "5px",
                          verticalAlign: "middle",
                        }}
                      />
                      No
                    </>
                  ) : parameterData?.mappings[0]?.actual_response ===
                    "Not Sure" ? (
                    <>
                      <HelpOutlineIcon
                        style={{
                          color: "#ff9800",
                          marginRight: "5px",
                          verticalAlign: "middle",
                        }}
                      />
                      Not Sure
                    </>
                  ) : (
                    ""
                  )}
                </Item>

                <Item
                  // className="datatype-wrap"
                  style={{
                    width: columnWidths?.input8,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  sx={
                    role !== "preProcessor" && {
                      ...(Validation(
                        parametersData[parameterIndex]?.dataType,
                        parametersData[parameterIndex]?.range,
                        parameterData?.mappings[0]?.value
                      )?.error && {
                        border: "2px solid!important",
                        borderRadius: "5px!important",
                        borderColor: "#ff9800!important",
                      }),
                    }
                  }
                >
                  {/* <Label
                      text={parameterData?.mappings[0]?.value}
                      fontSize="16px"
                    /> */}
                  <ValidatorValueEditableCell
                    textValue={parameterData?.mappings[0]?.value}
                    parametersData={parametersData}
                    mapping={parameterData?.mappings[0]}
                    mappingIndex={0}
                    // rowRejectionData={rowRejectionData}
                  />

                  {
                    // role === "preProcessor" &&
                    // (parameterData?.mappings[0]?.processorCellRejection
                    //   ?.isRejected === true ||
                    //   (parameterData?.mappings[0]?.pageNo >= 0 &&
                    //     parameterData?.mappings[0]?.tagName &&
                    //     (parameterData?.mappings[0]?.parameter_question ||
                    //       parameterData?.mappings[0]
                    //         ?.parameter_question === ""))) && (
                    //          ||
                    // role === "processor" ||
                    // role === "validator"
                    <CellMenu
                      parameter_question={
                        parameterData?.mappings[0]?.parameter_question
                      }
                      // updateParameterQuestion={(question) =>
                      //   updateParameterQuestion(question, parameterIndex, 0)
                      // }
                      // isRejectedByProcessor={
                      //   parameterData?.mappings[0]?.processorCellRejection
                      //     ?.isRejected
                      // }
                      // processorRejectionRemark={
                      //   parameterData?.mappings[0]?.processorCellRejection
                      //     ?.remark
                      // }
                      // isRejectedByValidator={
                      //   parameterData?.mappings[0]?.validatorCellRejection
                      //     ?.isRejected
                      // }
                      // validatorRejectionRemark={
                      //   parameterData?.mappings[0]?.validatorCellRejection
                      //     ?.remark
                      // }
                      // rejectCell={(rejectionRemark) =>
                      //   rejectCell(
                      //     rejectionRemark,
                      //     parameterIndex,
                      //     mappingIndex
                      //   )
                      // }
                      // deleteRejection={() =>
                      //   deleteRejection(parameterIndex, mappingIndex)
                      // }
                      role={role}
                      // markAsResolveByProcessor={() =>
                      //   markAsResolveByProcessor(
                      //     parameterIndex,
                      //     mappingIndex
                      //   )
                      // }
                      // isRwoValidated={
                      //   parameterData?.rowValidation?.isValidated
                      // }
                      // heading={
                      //   role === "preProcessor"
                      //     ? action.REJECTION_REMARK
                      //     : action.REJECTION_PROMPT
                      // }
                      // isResolvedProcessorCellRejection={
                      //   parameterData?.mappings[0]?.processorCellRejection
                      //     ?.isResolved
                      // }
                      // isResolvedValidatorCellRejection={
                      //   parameterData?.mappings[0]?.validatorCellRejection
                      //     ?.isResolved
                      // }
                      // reInitiateProVlm={
                      //   parameterData?.mappings[0]?.reInitiateProVlm
                      // }
                      // handleChangeReProcess={(type) =>
                      //   handleChangeReProcess(
                      //     type,
                      //     parameterIndex,
                      //     mappingIndex
                      //   )
                      // }
                      // processorsRejectionCounts={
                      //   processorsRejectionCounts
                      // }
                      // reProcessVlmCounts={reProcessVlmCounts}
                      // ref={cellMenuRef} // new for qc context to auto open on mapping
                      showMenuButton={
                        parameterData?.mappings[0]?.processorCellRejection
                          ?.isRejected === true ||
                        (parameterData?.mappings[0]?.pageNo >= 0 &&
                        parameterData?.mappings[0]?.tagName &&
                        (parameterData?.mappings[0]?.parameter_question ||
                          parameterData?.mappings[0]?.parameter_question === "")
                          ? true
                          : false)
                      } // new prop as in qc pre we want to assign ref so we need to open bydefault this component
                      isShowDeleteButton={false}
                      onlyShowParameterQuestion={true}
                    />
                    // )
                  }
                </Item>

                {/*  Validator Comment */}
                <Item
                  // className="datatype-wrap"
                  style={{
                    width: columnWidths?.input5,
                    justifyContent: "center",
                  }}
                >
                  <QCComment
                    comment={parameterData?.validatorComment}
                    addComment={addComment}
                    deleteComment={deleteComment}
                    role={role}
                    isReadOnly={false}
                    heading={"Comment"}
                    parameterIndex={parameterIndex}
                  />
                </Item>

                {/*  processor Comment */}
                <Item
                  // className="datatype-wrap"
                  style={{
                    width: columnWidths?.input9,
                    justifyContent: "center",
                  }}
                >
                  <QCComment
                    comment={parameterData?.processorComment}
                    // addComment={addComment}
                    // deleteComment={deleteComment}
                    role={role}
                    isReadOnly={true}
                    heading={"Comment"}
                    parameterIndex={parameterIndex}
                  />
                </Item>

                <Item
                  // className="datatype-wrap"
                  className="no-border"
                  style={{
                    maxWidth: columnWidths?.input6,
                    justifyContent: "center",
                  }}
                >
                  <ValidationButton
                    onClickValidate={onClickValidate}
                    parameterData={parameterData}
                    parameterIndex={parameterIndex}
                  />
                </Item>

                <Item
                  className="no-border"
                  // className="datatype-wrap"
                  style={{
                    width: columnWidths?.input3,
                    justifyContent: "center",
                  }}
                >
                  <QCRowRejectAndReviewNew
                    isFirstCheckbox={false}
                    handleRowRejection={handleRowRejection}
                    parameterData={parameterData}
                    deleteRowRejection={deleteRowRejection}
                    role={role}
                    markAsResolveRejection={markAsResolveRejection}
                    parameterIndex={parameterIndex}
                    heading={"Do you want to reject the row?"}
                    reProcessVlmCounts={reProcessVlmCounts}
                  />
                </Item>

                {
                  reProcess && ( // this is view of rejection after reprocess/resolve byother user
                    // parameterData?.mappings[0]?.processorCellRejection?.isResolved && (
                    <Item
                      className="no-border"
                      // className="datatype-wrap"
                      style={{
                        width: columnWidths?.input4,
                        justifyContent: "center",
                        pointerEvents: parameterData?.mappings[0]
                          ?.processorCellRejection?.isResolved
                          ? "auto"
                          : "none",
                        opacity: parameterData?.mappings[0]
                          ?.processorCellRejection?.isResolved
                          ? 1
                          : 0.5,
                      }}
                      disabled
                    >
                      <QCRowRejectAndReviewNew
                        parameterData={parameterData}
                        role={role}
                        parameterIndex={parameterIndex}
                        heading={"View Remark"}
                        disableFooterBtns={true}
                        icon="view"
                      />
                    </Item>
                  )
                  // )
                }

                {role === "validator" &&
                  parameterData?.mappings[0]?.validatorCellRejection
                    ?.isResolved && (
                    // parameterData?.validatorRowRejection?.isResolved
                    <Grid Item className="reject-cell">
                      <QCRowRejectAndReviewNew
                        parameterData={parameterData}
                        role={role}
                        parameterIndex={parameterIndex}
                        heading={"View Remark"}
                        disableFooterBtns={true}
                        icon="view"
                      />

                      {/* <RowRejectAndReviewNew
                              parameterData={parameterData}
                              role={role}
                              parameterIndex={parameterIndex}
                              heading={"View Remark"}
                              disableFooterBtns={true}
                              icon="view"
                            /> */}
                    </Grid>
                  )}
              </Grid>
            ))}
          </Grid>
          {/* </div> */}
        </Box>
      )}

      {isAlert?.open && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          key={"topcenter"}
        >
          <Alert onClose={handleClose} className="error-alert" severity="error">
            <AlertTitle color="white">{isAlert?.title}</AlertTitle>
            {isAlert?.message}
          </Alert>
        </Snackbar>
      )}

      {openAuth && (
        <Authentication
          openAuth={openAuth}
          handleClose={() => setOpenAuth(false)}
          handleUserPermission={handleUserPermission}
        />
      )}

      {openSignPad && (
        <ModalSign
          openSignPad={openSignPad}
          handleEsignDialogBoxClose={handleEsignDialogBoxClose}
        ></ModalSign>
      )}
    </Box>
  );
});
